import { twMerge } from "tailwind-merge"

const Section: React.FC<{ children: React.ReactNode; padding?: string; maxWidth?: string; className?: string }> = ({
  children,
  className,
}) => (
  <section
    className={twMerge(
      `mx-auto px-[1rem] md:px-0 max-w-content px-page-x lg:px-[1rem] max-w-7xl py-[4rem] md:py-[7rem]`,
      className,
    )}>
    {children}
  </section>
)

export default Section
